import styled from 'styled-components';
import { mediaQueryDesktopMin } from 'styleUtils';
var Wrapper = /*#__PURE__*/styled.main.withConfig({
  componentId: "sc-q09h8x-0"
})(["align-items:flex-start;display:flex;flex-flow:row wrap;width:100%;@media ", "{padding-right:24px;width:calc(100% - 300px);}"], mediaQueryDesktopMin);
export default Wrapper;